import React from 'react';
import { Link } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  return (
    <main className="page-not-found" role="main">
      <div className="not-found-card">
        <h1 className="wordmark">404</h1>
        <p className="not-found-text">This page does not exist.</p>
        <Link to="/" className="action-btn action-btn-secondary">
          Return to heart
        </Link>
      </div>
    </main>
  );
};
